export default function validateImgExp(filename) {
    return filename.includes('.psd') || filename.includes('.png') || filename.includes('.jpg') || filename.includes('.jpeg');
}